<template comments>
  <div class="mwe-panel">
    <div class="mwe-panel-hd">
      <h3 class="mwe-panel-title">
        <!-- 每日12点抢e商店无门槛红包 -->
        <slot name="title"></slot>
      </h3>
      <p v-if="this.$slots.desc" class="mwe-panel-desc">
        <!-- 抽奖活动时间：xx月xx日  -->
        <slot name="desc"></slot>
      </p>
    </div>
    <div class="mwe-panel-bd">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  }
};
</script>
